import { render } from "./comp-form.vue?vue&type=template&id=5755b5c4&ts=true"
import script from "./comp-form.vue?vue&type=script&lang=ts"
export * from "./comp-form.vue?vue&type=script&lang=ts"

import "./comp-form.vue?vue&type=style&index=0&id=5755b5c4&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__